import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { add } from 'utils/generic/calculator';
import { isMobile } from 'utils/is-mobile';
import { formatPrice } from 'utils/string-manipulation/format-price';
import { Button } from 'newcomponents/UI/Button';
import { useCurrency } from 'hooks/useCurrency';
import { usePredefinedStakes } from 'hooks/usePredefinedStakes';
import { getIsLoggedIn } from 'store/selectors/user-data';
import './index.less';

type Props = {
  onChange: (value: string) => void;
  changeCurrentStake?: (val: string) => void;
  setSelected?: Function;
  disabled?: boolean;
  currentStake?: number | string;
};
// @Todo need to remove usage from CustomKeyboard (as we have task to update custom keyboard logic, we can replace this component with new one from newelemetns/_betslip folder during that task/)
export const PredefinedStakes: FC<Props> = memo(
  ({ onChange, changeCurrentStake, setSelected, disabled, currentStake }) => {
    const isLoggedIn = useSelector(getIsLoggedIn);
    const { predefinedStakes } = usePredefinedStakes();

    const onPredefinedInput = (value: string | number) => {
      const stake = add(+value, currentStake ? +currentStake : 0);
      const valueToUpdate = SpringConfigs.PREDEFINE_STAKES_ADDING
        ? stake
        : value;

      if (changeCurrentStake) {
        changeCurrentStake(valueToUpdate.toString());
      }

      onChange(valueToUpdate.toString());
    };

    const { formatAmount } = useCurrency();

    const checkIsPredefinedStakesVisible = (): boolean => {
      const { stake_1, stake_2, stake_3 } = predefinedStakes;

      return !(!stake_1 || !stake_2 || !stake_3);
    };

    return (
      <div
        className={!isMobile() ? 'predefined--container' : 'predefined--mobile'}
      >
        {checkIsPredefinedStakesVisible() &&
          Object.keys(predefinedStakes).map(key => {
            const value =
              predefinedStakes[key as keyof typeof predefinedStakes];

            if (key === 'default_stake') {
              return;
            }

            const regEx = new RegExp(SpringConfigs.PRICE_SEPARATOR, 'g');

            return (
              <Button
                className={cc([
                  'predefined--button',
                  {
                    'predefined--mobileButton': isMobile(),
                    'predefined--buttonActive':
                      +value?.replace(regEx, '') === +(currentStake || 0)
                  }
                ])}
                disabled={disabled}
                key={key}
                size="large"
                type="cancel"
                fullwidth
                onClick={() => {
                  if (setSelected) {
                    setSelected('general');
                  }

                  onPredefinedInput(
                    typeof value === 'number' ? value : value.replace(regEx, '')
                  );
                }}
              >
                {SpringConfigs.PREDEFINE_STAKES_ADDING ? '+' : null}
                {formatAmount(
                  formatPrice(
                    typeof value === 'number'
                      ? value
                      : value.replace(regEx, ''),
                    SpringConfigs.PRICE_SEPARATOR
                  ),
                  isLoggedIn
                )}
              </Button>
            );
          })}
      </div>
    );
  }
);
